import dateQuickPickerTemplate from './dateQuickPicker.html';

function directive() {
  return {
    restrict: 'E',
    scope: {
      date: '=',
      update: '&',
      pickerDisabled: '='
    },
    template: dateQuickPickerTemplate,
    controller: [
      '$scope',
      ($scope) => {
        $scope.setDate = (date) => {
          $scope.date = date;
        };
      }]
  };
}

export default function (ngModule) {
  ngModule.directive('dateQuickPicker', directive);
}
